import type { VoiceBrowserControl, VoiceDictationControl } from '../../../src/shared/wireContract';

/** Calls and dictation share the same-origin, one-shot ticket transport. */
export function createVoiceSocket(sessionId: string, ticket: string): WebSocket {
  const url = new URL('/ws/voice/' + encodeURIComponent(sessionId), window.location.origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'; url.searchParams.set('ticket', ticket);
  return new WebSocket(url);
}

/** Retire callbacks before closing a socket so cleanup cannot dispatch a new session event. */
export function clearVoiceSocketHandlers(socket: WebSocket): void {
  socket.onopen = null; socket.onmessage = null; socket.onclose = null; socket.onerror = null;
}

/** A cancelled reservation owns its bounded cleanup independently of the next attempt or disposal. */
export function consumeVoiceTicket(
  factory: (sessionId: string, ticket: string) => WebSocket,
  sessionId: string,
  ticket: string,
  control: Extract<VoiceBrowserControl, { type: 'hangup' }> | Extract<VoiceDictationControl, { type: 'cancel' }>,
): void {
  const socket = factory(sessionId, ticket);
  const close = (): void => { clearTimeout(timeout); clearVoiceSocketHandlers(socket); socket.close(); };
  const timeout = setTimeout(close, 15_000);
  socket.onopen = () => { socket.send(JSON.stringify(control)); close(); };
  socket.onerror = close; socket.onclose = close;
}
